<template>
  <div class="row" style="margin-top:5%">
    <div class="col-md-4">
      <h3 class="text-lg-center mor">Sınav İstatistiğiniz</h3>
      <b-img fluid class="img" src="../assets/images/istatistik.png"/>
    </div>
    <div class="col-md-7">
      <div class="row">
        <div class="container" v-show="sinav.videoCozumVarMi === true">
          <b-button v-show="sinav.videourl || sinav.embedcode"  :to="{name: 'VideoGoster', params: { url:sinav.videourl, videoadi: sinav.denemeAdi, embedcode: sinav.embedcode }}" size="sm" variant="primary" class="mr-2">
            Çözüm Videosu İzle
          </b-button>
        </div>
      </div>
      <div>
        <b-container>
          <h3>Tebrikler, sınavınızı kaydettik</h3>
          <p>Bu sınav ekranına istediğiniz zaman girip, sınav cevaplarını görüp değiştirebilirsiniz. </p>
          <strong v-if="open == 'false'">Sınavda hata yaptığınız soruları aşağıdaki listeden bulup, çözümlerini ve hangi şıkka neden gitmemeniz gerektiğini öğretmenlerimizden dinleyin.</strong>
        </b-container>
<!--        <h3>Öğretmen Değerlendirmesi</h3>-->
<!--        <div v-if="!cozulenDeneme.degerlendirecekOgretmen">-->
<!--        <p>-->
<!--          <label>Öğretmenimizin sınavınızı değerlendirmesini talep ediyorsanız. Burayı işaretleyip formu doldurunuz.</label>-->
<!--          <b-form-checkbox-->
<!--            id="checkbox-1"-->
<!--            v-model="open"-->
<!--            name="checkbox-1"-->
<!--            value="true"-->
<!--            unchecked-value="false"-->
<!--          />-->
<!--        </p>-->
<!--        </div>-->
        <div v-if="!cozulenDeneme.degerlendirecekOgretmen && open == 'true'">
        <h5>Sınav değerlendirmenizin doğru olabilmesi için</h5>
        <b-list-group style="margin-bottom: 50px">
          <b-list-group-item>1) Sınavda hata yaptığınız soruları aşağıdaki listeden bulup, çözümlerini ve hatalı şıkları öğretmenlerimizden dinleyin.</b-list-group-item>
          <b-list-group-item>2) Değerlendirmemizde bize yardımcı olacak aşağıdaki alanları doldurup gönderin</b-list-group-item>
          <b-list-group-item>3) Değerlendirmeniz yapıldığında size mail yolu ile bilgi vereceğiz.</b-list-group-item>
        </b-list-group>
        <b-form>
          <b-form-group
            id="input-group-1"
            label="Hedef Puanınız:"
            label-for="hedefPuan"
          >
            <b-form-input
              id="hedefPuan"
              v-model="form.hedefPuan"
              type="number"
              required
              placeholder="Hedef Puanınızı Yazınız"
            ></b-form-input>
          </b-form-group>
          <b-form-group id="input-group-2" label="Sınava Nasıl Hazırlandınız? Hangi kaynakları kullandınız? Kaç deneme çözdünüz ? Nasıl çalıştığınızı detaylı bir şekilde anlatın." label-for="input-2">
            <b-form-textarea
              id="ogrenciaciklama"
              v-model="form.ogrenciAciklama"
              placeholder="Nasıl Çalıştığınızı Anlatın."
              rows="5"
              max-rows="10"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group id="input-group-3" label="Sınavınızı hangi öğretmenimiz değerlendirsin.">
            <b-form-select v-model="selected" :options="options"></b-form-select>
          </b-form-group>
          <b-button @click="degerlendirmeKaydet" variant="primary">Kaydet</b-button>
        </b-form>
        </div>
        <div v-if="cozulenDeneme.degerlendirecekOgretmen">
          <b-list-group style="margin-bottom: 50px">
            <b-list-group-item  v-if="cozulenDeneme.geriBildirimSes">Sınavınızı  {{ cozulenDeneme.degerlendirecekOgretmen }} Hoca Değerlendirdi!</b-list-group-item>
            <b-list-group-item v-if="cozulenDeneme.geriBildirimSes">
              <audio controls>
                <source :src="audiourl" />
              </audio>
              <p>
                Dinlemekte sorun yaşıyorsanız.
                <a :href="audiourl">Buraya tıklayınız!</a>
              </p>
            </b-list-group-item>
            <b-list-group-item  v-if="!cozulenDeneme.geriBildirimSes">Sınavınızı  {{ cozulenDeneme.degerlendirecekOgretmen }} Hoca Değerlendirecek</b-list-group-item>
            <b-list-group-item v-if="!cozulenDeneme.geriBildirimSes">Değerlendirmeniz yapıldığında size mail yolu ile bilgi vereceğiz. Öğretmenimiz henüz değerlendirmesini tamamlamadı.</b-list-group-item>
          </b-list-group>
        </div>
      </div>

      <h3>Sınav Sonuçlarınız</h3>
      <p>Sınavda hata yaptığınız soruları aşağıdaki listeden bulup, çözümlerini ve hangi şıkka neden gitmemeniz gerektiğini öğretmenlerimizden dinleyin.</p>
    <b-table striped hover :items="sinavGenelBilgi"></b-table>
    <b-table hover :items="sorular" :fields="alanlar">
      <template slot="kullanicicevap.dogruMu"  slot-scope="data">
        <!--{{data.item.kullanicicevap.dogruMu == 1?'+':'-'}}-->
        {{!data.item.kullanicicevap?'o':data.item.kullanicicevap.dogruMu ? '+' : '-'}}
      </template>
      <template slot="islemler"  slot-scope="data">
        <b-button size="sm"  variant="primary" @click="showSoruOnIzlemeSoru(data.item)">
          Soruyu Gör
        </b-button>
            <b-button v-show="data.item.SoruCozumVideoURL"  :to="{name: 'VideoGoster', params: { url:data.item.SoruCozumVideoURL, videoadi: 'Soru Çözümü', embedcode: ''}}" size="sm" variant="primary" class="mr-2">
            Çözüm Videosu İzle
            </b-button>
<!--        <b-button v-if="data.item.SoruCozumVideoURL ? true : fal" size="sm" variant="primary" @click="showSoruOnIzlemeSoru(data.item)">-->
<!--          Soru Çözümünü Gör-->
<!--        </b-button>-->
        <!--<b-button size="sm" variant="success">-->
          <!--Video Çözümü İzle-->
        <!--</b-button>-->
      </template>
    </b-table>
    </div>
    <b-container style="margin-bottom: 30px;margin-top: 30px">
      <h3>Sınav Sonuçlarınıza Göre Önerilerimiz</h3>
      <b-row>
        <b-col v-if="toplamPuan < 41" sm="4">
          <b-card
            title="Temel Seviye Ders"
            img-src="https://www.ankaradil.com/255-large_default/2020-ilkbahar-temel-seviye-kayittan-yds-yokdil-dersi.jpg"
            img-alt="Temel Seviye Resim"
            img-top
            tag="article"
            style="max-width: 20rem;"
            class="mb-2"
          >
            <b-card-text>
              40 ve altı puan alanlar için Temel Seviye Eğitimlerimizi öneriyoruz
            </b-card-text>

            <b-button target="_blank" href="https://www.ankaradil.com/12-canli-yds-dersleri-" variant="primary">Canlı Dersler</b-button>
            <b-button target="_blank" href="https://www.ankaradil.com/22-kayittan-dersler" variant="warning">Kayıttan Dersler</b-button>
          </b-card>
        </b-col>
        <b-col v-if="toplamPuan > 41  && toplamPuan < 61 " sm="4">
          <b-card
            title="İleri Seviye Ders"
            img-src="https://www.ankaradil.com/257-large_default/2020-ilkbahar-ileri-seviye-kayittan-yds-yokdil-dersi.jpg"
            img-alt="İleri Seviye Resim"
            img-top
            tag="article"
            style="max-width: 20rem;"
            class="mb-2"
          >
            <b-card-text>
              40 - 60 arası puan alanlar için İleri Seviye Eğitimlerimizi öneriyoruz
            </b-card-text>

            <b-button target="_blank" href="https://www.ankaradil.com/12-canli-yds-dersleri-" variant="primary">Canlı Dersler</b-button>
            <b-button target="_blank" href="https://www.ankaradil.com/22-kayittan-dersler" variant="warning">Kayıttan Dersler</b-button>
          </b-card>
        </b-col>
        <b-col v-if="toplamPuan > 60" sm="4">
          <b-card
            title="Pro Grup Ders"
            img-src="https://www.ankaradil.com/267-large_default/pro-grup-kayittan-yds-dersi-ilkbahar-2020.jpg"
            img-alt="Pro Grup Resim"
            img-top
            tag="article"
            style="max-width: 20rem;"
            class="mb-2"
          >
            <b-card-text>
              60 ve üzeri puan alanlar için Pro Grup Eğitimlerimizi öneriyoruz
            </b-card-text>

            <b-button target="_blank" href="https://www.ankaradil.com/12-canli-yds-dersleri-" variant="primary">Canlı Dersler</b-button>
            <b-button target="_blank" href="https://www.ankaradil.com/22-kayittan-dersler" variant="warning">Kayıttan Dersler</b-button>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="4" v-if="Number(yanlislar.Kelime || 0) > 3">
          <b-card
            title="WordUp"
            img-src="https://www.ankaradil.com/181-large_default/word-up.jpg"
            img-alt="WordUp Resim"
            img-top
            tag="article"
            style="max-width: 20rem;"
            class="mb-2"
          >
            <b-card-text>
              8 Kelime Sorusunda 4 veya daha fazla hata yaptığınız için size WORD UP kelime öğrenme sistemini öneriyoruz.
            </b-card-text>

            <b-button target="_blank" href="https://www.ankaradil.com/yds-yokdil-yks-dil-kelime-kitaplari/76-word-up.html" variant="primary">İncele</b-button>
          </b-card>
        </b-col>
        <b-col sm="4" v-if="Number(yanlislar.Grammer) > 1">
          <b-card
            title="Focus On Grammar"
            img-src="https://www.ankaradil.com/276-large_default/ankara-dil-kitap-focus-on-grammar.jpg"
            img-alt="Focus On Grammar Resim"
            img-top
            tag="article"
            style="max-width: 20rem;"
            class="mb-2"
          >
            <b-card-text>
              5 Grammer Sorusundan 2 veya daha fazla yanlış yaptığınız için size FOCUS ON GRAMMAR TESTS kitabında bulunan “Dilbilgisi testleri”ni çözmeyi öneriyoruz.
            </b-card-text>
            <div>
              <b-button target="_blank" href="https://www.ankaradil.com/yds-hazirlik-kitaplari/56-ankara-dil-kitap-focus-on-grammar.html" variant="primary">İncele</b-button>
            </div>
          </b-card>
        </b-col>
        <b-col sm="4" v-if="Number(yanlislar.Preposition) > 1">
          <b-card
            title="Focus On Grammar"
            img-src="https://www.ankaradil.com/276-large_default/ankara-dil-kitap-focus-on-grammar.jpg"
            img-alt="Focus On Grammar Resim"
            img-top
            tag="article"
            style="max-width: 20rem;"
            class="mb-2"
          >
            <b-card-text>
              4 Preposition sorousunda 2 veya daha fazla hata yaptığınız için size FOCUS ON GRAMMAR TESTS kitabında bulunan “Presposition testleri”ni çözmeyi öneriyoruz.
            </b-card-text>
            <div>
              <b-button target="_blank" href="https://www.ankaradil.com/yds-hazirlik-kitaplari/56-ankara-dil-kitap-focus-on-grammar.html" variant="primary">İncele</b-button>
            </div>
          </b-card>
        </b-col>
        <b-col sm="4" v-if="Number(yanlislar.Baglac) > 1">
          <b-card
            title="Focus On Grammar"
            img-src="https://www.ankaradil.com/276-large_default/ankara-dil-kitap-focus-on-grammar.jpg"
            img-alt="Focus On Grammar Resim"
            img-top
            tag="article"
            style="max-width: 20rem;"
            class="mb-2"
          >
            <b-card-text>
              9 Bağlaç sorusunda, 2 veya daha fazla hata yaptığınız için size FOCUS ON GRAMMAR TESTS kitabında bulunan “Bağlaç testleri”ni çözmeyi öneriyoruz.
            </b-card-text>
            <div>
              <b-button target="_blank" href="https://www.ankaradil.com/yds-hazirlik-kitaplari/56-ankara-dil-kitap-focus-on-grammar.html" variant="primary">İncele</b-button>
            </div>
          </b-card>
        </b-col>
        <b-col sm="4" v-if="Number(yanlislar.CTamamlama) > 2">
          <b-card
            title="Focus On YDS İlk 36"
            img-src="https://www.ankaradil.com/277-large_default/ankara-dil-kitap-focus-on-yds-ilk-36.jpg"
            img-alt="Focus On YDS İlk 36 Resim"
            img-top
            tag="article"
            style="max-width: 20rem;"
            class="mb-2"
          >
            <b-card-text>
              10 Cümle Tamamlama sorusunda, 3 veya daha fazla yaptığınız için FOCUS ON YDS İLK 36 test kitabının çözülmesini öneriyoruz.
            </b-card-text>
            <div>
              <b-button target="_blank" href="https://www.ankaradil.com/yds-hazirlik-kitaplari/52-ankara-dil-kitap-focus-on-yds-ilk-36.html" variant="primary">İncele</b-button>
            </div>
          </b-card>
        </b-col>
        <b-col sm="4" v-if="Number(yanlislar.Ceviri) > 1">
          <b-card
            title="VİDEO ÇÖZÜMLÜ 10 YDS DENEME SINAVI"
            img-src="https://www.ankaradil.com/283-large_default/video-cozumlu-10-yds-deneme-sinavi.jpg"
            img-alt="VİDEO ÇÖZÜMLÜ 10 YDS DENEME SINAVI Resim"
            img-top
            tag="article"
            style="max-width: 20rem;"
            class="mb-2"
          >
            <b-card-text>
              6 Çeviri sorusunda 2 veya daha fazla hata yağtığınız için 10 ÇÖZÜMLÜ YDS DENEME kitabı ve ÇIKMIŞ YDS SORULARI’nın çözülmesini öneriyoruz.
            </b-card-text>
            <div>
              <b-button target="_blank" href="https://www.ankaradil.com/video-cozumlu-yds-deneme-sinavlari/116-video-cozumlu-10-yds-deneme-sinavi.html" variant="primary">İncele</b-button>
            </div>
          </b-card>
        </b-col>
        <b-col sm="4" v-if="Number(yanlislar.Ceviri) > 1">
          <b-card
            title="VİDEO ÇÖZÜMLÜ 10 YDS DENEME SINAVI 2"
            img-src="https://www.ankaradil.com/369-large_default/video-cozumlu-10-yds-deneme-sinavi-2.jpg"
            img-alt="VİDEO ÇÖZÜMLÜ 10 YDS DENEME SINAVI 2 Resim"
            img-top
            tag="article"
            style="max-width: 20rem;"
            class="mb-2"
          >
            <b-card-text>
              6 Çeviri sorusunda 2 veya daha fazla hata yağtığınız için 10 ÇÖZÜMLÜ YDS DENEME kitabı ve ÇIKMIŞ YDS SORULARI’nın çözülmesini öneriyoruz.
            </b-card-text>
            <div>
              <b-button target="_blank" href="https://www.ankaradil.com/video-cozumlu-yds-deneme-sinavlari/246-video-cozumlu-10-yds-deneme-sinavi-2.html" variant="primary">İncele</b-button>
            </div>
          </b-card>
        </b-col>
        <b-col sm="4" v-if="Number(yanlislar.Paragraf) > 4">
          <b-card
            title="OKUMA STRATEJİLERİ PROGRAMI / MORE THAN READING KİTABI"
            img-src="https://egitim.ankaradil.com/pluginfile.php/45777/course/overviewfiles/16-9-Tjn-okuma-k.jpg"
            img-alt="MORE THAN READING KİTABI Resim"
            img-top
            tag="article"
            style="max-width: 20rem;"
            class="mb-2"
          >
            <b-card-text>
              20 Paragraf sorusunda 5 veya daha fazla hata yaptığınız için size  OKUMA STRATEJİLERİ PROGRAMI veya MORE THAN READING KİTABI’nı öneriyoruz. Ayrıca, sosyal medya hesaplarımızdan sürekli paylaştığımız websitelerini takip ederek düzenli güncel okuma yapmak faydalı olacaktır.
            </b-card-text>
            <div>
              <b-button target="_blank" href="https://www.ankaradil.com/kayittan-dersler/111-yds-okuma-stratejileri-ceviri-ve-kelime-dersi-kayittan.html" variant="primary">İncele</b-button>
            </div>
          </b-card>
        </b-col>
        <b-col sm="4" v-if="Number(yanlislar.Paragraf) > 4">
          <b-card
            title="READING IN DETAIL DERSİ / READING IN DETAIL KİTABI"
            img-src="https://www.ankaradil.com/313-large_default/reading-in-detail-video-ders.jpg"
            img-alt="READING IN DETAIL DERSİ RESMİ"
            img-top
            tag="article"
            style="max-width: 20rem;"
            class="mb-2"
          >
            <b-card-text>
              20 Paragraf sorusunda 5 veya daha fazla hata yaptığınız için size  READING IN DETAIL  PROGRAMI veya READING IN DETAIL KİTABI’nı öneriyoruz. Ayrıca, sosyal medya hesaplarımızdan sürekli paylaştığımız websitelerini takip ederek düzenli güncel okuma yapmak faydalı olacaktır.
            </b-card-text>
            <div>
              <b-button target="_blank" href="https://www.ankaradil.com/okuma-stratejileri-ceviri-ve-kelime-kayittan/197-reading-in-detail-video-ders.html" variant="primary">İncele</b-button>
            </div>
          </b-card>
        </b-col>
        <b-col sm="4" v-if="Number(yanlislar.Dialog) > 0">
          <b-card
            title="VİDEO ÇÖZÜMLÜ 10 YDS DENEME SINAVI"
            img-src="https://www.ankaradil.com/283-large_default/video-cozumlu-10-yds-deneme-sinavi.jpg"
            img-alt="VİDEO ÇÖZÜMLÜ 10 YDS DENEME SINAVI Resim"
            img-top
            tag="article"
            style="max-width: 20rem;"
            class="mb-2"
          >
            <b-card-text>
              5 Diyalog sorusunda 1 ve daha fazla hata yaptığınız için 10 ÇÖZÜMLÜ YDS DENEME kitabı ve ÇIKMIŞ YDS SORULARI’nın çözülmesini öneriyoruz. Ayrıca, FİLM/DİZİ İZLEMEK ELBETTE İŞE YARAR.
            </b-card-text>
            <div>
              <b-button target="_blank" href="https://www.ankaradil.com/video-cozumlu-yds-deneme-sinavlari/116-video-cozumlu-10-yds-deneme-sinavi.html" variant="primary">İncele</b-button>
            </div>
          </b-card>
        </b-col>
        <b-col sm="4" v-if="Number(yanlislar.Dialog) > 0">
          <b-card
            title="VİDEO ÇÖZÜMLÜ 10 YDS DENEME SINAVI - 2"
            img-src="https://www.ankaradil.com/369-large_default/video-cozumlu-10-yds-deneme-sinavi-2.jpg"
            img-alt="VİDEO ÇÖZÜMLÜ 10 YDS DENEME SINAVI 2 Resim"
            img-top
            tag="article"
            style="max-width: 20rem;"
            class="mb-2"
          >
            <b-card-text>
              5 Diyalog sorusunda 1 ve daha fazla hata yaptığınız için 10 ÇÖZÜMLÜ YDS DENEME kitabı ve ÇIKMIŞ YDS SORULARI’nın çözülmesini öneriyoruz. Ayrıca, FİLM/DİZİ İZLEMEK ELBETTE İŞE YARAR.
            </b-card-text>
            <div>
              <b-button target="_blank" href="https://www.ankaradil.com/video-cozumlu-yds-deneme-sinavlari/246-video-cozumlu-10-yds-deneme-sinavi-2.html" variant="primary">İncele</b-button>
            </div>
          </b-card>
        </b-col>
        <b-col sm="4" v-if="Number(yanlislar.YAnlam) > 0">
          <b-card
            title="FOCUS ON EXTRA TESTS"
            img-src="https://www.ankaradil.com/275-large_default/ankara-dil-kitap-yds-focus-on-extra-tests.jpg"
            img-alt="FOCUS ON EXTRA TESTS Resim"
            img-top
            tag="article"
            style="max-width: 20rem;"
            class="mb-2"
          >
            <b-card-text>
              4 Yakın Anlam sorusunda 1 veya daha fazla yanlış yaptığınız için FOCUS ON EXTRA TESTS kitabı ve ÇIKMIŞ YDS SORULARI’nın çözülmesini öneriyoruz. Ayrıca, OKUMA STRATEJİLERİ PROGRAMI VEYA MORE THAN READING KİTABI bu soru türünde ustalaşmanıza yardımcı olacaktır.
            </b-card-text>
            <div>
              <b-button target="_blank" href="https://www.ankaradil.com/yds-hazirlik-kitaplari/57-ankara-dil-kitap-yds-focus-on-extra-tests.html" variant="primary">İncele Extra Tests</b-button>
            </div>
            <div>
              <b-button target="_blank" href="https://www.ankaradil.com/kayittan-dersler/111-yds-okuma-stratejileri-ceviri-ve-kelime-dersi-kayittan.html" variant="warning">İncele OKUMA STRATEJİLERİ</b-button>
            </div>
          </b-card>
        </b-col>
        <b-col sm="4" v-if="Number(yanlislar.PTamamlama) > 0">
          <b-card
            title="FOCUS ON EXTRA TESTS"
            img-src="https://www.ankaradil.com/275-large_default/ankara-dil-kitap-yds-focus-on-extra-tests.jpg"
            img-alt="FOCUS ON EXTRA TESTS Resim"
            img-top
            tag="article"
            style="max-width: 20rem;"
            class="mb-2"
          >
            <b-card-text>
              4 Paragraf Tamamlama sorusunda 1 veya daha fazla yanlışınız olduğu için FOCUS ON EXTRA TESTS kitabı, FOCUS ON GRAMMAR TESTS kitabındaki Bağlaç testleri, 10 ÇÖZÜMLÜ YDS DENEME kitabı ve ÇIKMIŞ YDS SORULARI, OKUMA STRATEJİLERİ PROGRAMI VEYA MORE THAN READING KİTABI’nı öneriyoruz.
            </b-card-text>
            <div>
              <b-button target="_blank" href="https://www.ankaradil.com/56-yds-kitaplari" variant="primary">İncele Kitaplarımız</b-button>
            </div>-
          </b-card>
        </b-col>
        <b-col sm="4" v-if="Number(yanlislar.IrrelevantS) > 0">
          <b-card
            title="Kitaplarımız"
            img-src="https://www.ankaradil.com/274-large_default/ankara-dil-akademisi-yds-kitap-seti.jpg"
            img-alt="Kitaplarımız Resim"
            img-top
            tag="article"
            style="max-width: 20rem;"
            class="mb-2"
          >
            <b-card-text>
              5 Irrelevant Sentence sorusunda 1 ve daha fazla yanlışınız olduğu için FOCUS ON EXTRA TESTS kitabı, FOCUS ON GRAMMAR TESTS kitabındaki Bağlaç testleri, 10 ÇÖZÜMLÜ YDS DENEME kitabı ve ÇIKMIŞ YDS SORULARI, OKUMA STRATEJİLERİ PROGRAMI VEYA MORE THAN READING KİTABI’nı öneriyoruz.
            </b-card-text>
            <div>
              <b-button target="_blank" href="https://www.ankaradil.com/56-yds-kitaplari" variant="primary">İncele Kitaplarımız</b-button>
            </div>-
          </b-card>
        </b-col>
        <b-col sm="4" v-if="Number(yanlislar.ClozeTest) > 2">
          <b-card
            title="FOCUS ON CLOZE TESTS"
            img-src="https://www.ankaradil.com/278-large_default/focus-on-cloze-test-yds-kitabi-ankara-dil.jpg"
            img-alt="FOCUS ON CLOZE  Resim"
            img-top
            tag="article"
            style="max-width: 20rem;"
            class="mb-2"
          >
            <b-card-text>
              17 – 26 arası CLOZE TEST bölümünde, 3 ve daha fazla hata yaptığınız için FOCUS ON CLOZE TESTS kitabının çözülmesini öneriyoruz.
            </b-card-text>
            <div>
              <b-button target="_blank" href="https://www.ankaradil.com/yds-hazirlik-kitaplari/51-focus-on-cloze-test-yds-kitabi-ankara-dil.html" variant="primary">FOCUS ON CLOZE TESTS</b-button>
            </div>-
          </b-card>
        </b-col>
      </b-row>
    </b-container>
    <modal name="soruonizleme" transition="nice-modal-fade" :min-width="1200"  :min-height="600" :pivot-y="0.5" :adaptive="true" :scrollable="true"  width="60%" height="auto">
      <div class="container">
          <p><strong class="secenek">{{aktifSoru.SoruNo}})</strong>{{aktifSoru.Soru}}</p>
          <p v-bind:class='{dogruSecenek: !aktifSoru.kullanicicevap ? false : aktifSoru.kullanicicevap.cevap === "0"  && aktifSoru.Cevap === "0", yanlisSecenek: !aktifSoru.kullanicicevap?false:aktifSoru.kullanicicevap.cevap === "0" && aktifSoru.Cevap !== "0" , cevap: aktifSoru.Cevap === "0" }'><strong class="secenek">A)</strong>{{aktifSoru.Cevaplar?aktifSoru.Cevaplar[0] : ''}}</p>
          <p v-bind:class='{dogruSecenek: !aktifSoru.kullanicicevap ? false : aktifSoru.kullanicicevap.cevap === "1"  && aktifSoru.Cevap === "1", yanlisSecenek: !aktifSoru.kullanicicevap?false:aktifSoru.kullanicicevap.cevap === "1" && aktifSoru.Cevap !== "1" , cevap: aktifSoru.Cevap === "1" }'><strong class="secenek">B)</strong>{{aktifSoru.Cevaplar? aktifSoru.Cevaplar[1] : ''}}</p>
          <p v-bind:class='{dogruSecenek: !aktifSoru.kullanicicevap ? false : aktifSoru.kullanicicevap.cevap === "2"  && aktifSoru.Cevap === "2" , yanlisSecenek: !aktifSoru.kullanicicevap?false:aktifSoru.kullanicicevap.cevap === "2" && aktifSoru.Cevap !== "2" , cevap: aktifSoru.Cevap === "2" }'><strong class="secenek">C)</strong>{{aktifSoru.Cevaplar?aktifSoru.Cevaplar[2] : ''}}</p>
          <p v-bind:class='{dogruSecenek: !aktifSoru.kullanicicevap ? false : aktifSoru.kullanicicevap.cevap === "3"  && aktifSoru.Cevap === "3", yanlisSecenek: !aktifSoru.kullanicicevap?false:aktifSoru.kullanicicevap.cevap === "3" && aktifSoru.Cevap !== "3" , cevap: aktifSoru.Cevap === "3" }'><strong class="secenek">D)</strong>{{aktifSoru.Cevaplar?aktifSoru.Cevaplar[3] : ''}}</p>
          <p v-bind:class='{dogruSecenek: !aktifSoru.kullanicicevap ? false : aktifSoru.kullanicicevap.cevap === "4"  && aktifSoru.Cevap === "4", yanlisSecenek: !aktifSoru.kullanicicevap?false:aktifSoru.kullanicicevap.cevap === "4" && aktifSoru.Cevap !== "4" , cevap: aktifSoru.Cevap === "4" }'><strong class="secenek">E)</strong>{{aktifSoru.Cevaplar?aktifSoru.Cevaplar[4] : ''}}</p>
          <table class="table">
            <thead>
              <tr>
                <th>Sizin Cevabınız</th>
                <th>Doğru Cevap</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{!aktifSoru.kullanicicevap ? 'Boş Bıraktınız' : aktifSoru.kullanicicevap.cevapUserFriendly }}</td>
                <td>{{aktifSoru.UFCevap}}</td>
              </tr>
            </tbody>
          </table>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { numberToAnswer } from '../utility/statics'
import {getStatics, postDegerlendirmeTalebi} from '../utility/ajaxMethods'
import _ from 'lodash'
export default {
  name: 'SinavOZeti',
  data: () => {
    return {
      selected: null,
      options: [
        { value: null, text: 'Değerlendirmeyi hangi öğretmenin yapacağını seçiniz.' },
        { value: 'tijen', text: 'Tijen Hoca' },
        { value: 'umit', text: 'Ümit Hoca' }
      ],
      form: {
        hedefPuan: '',
        ogrenciAciklama: ''
      },
      showDismissibleAlert: false,
      sinavid: null,
      open: 'false',
      cozulenDeneme: {},
      yanlislar: {},
      sorular: [],
      cevaplar: [],
      aktifSoru: {Cevaplar: []},
      sinav: {},
      hata: '',
      sinavGenelBilgi: [],
      sinavDetayBilgi: [],
      alanlar: [{key: 'SoruNo', sortable: true, label: 'No'},
        {key: 'kullanicicevap.cevapUserFriendly', label: 'Cevap'},
        {key: 'UFCevap', label: 'Doğru Cevap'},
        {key: 'kullanicicevap.dogruMu', label: 'Sonuç'},
        {key: 'islemler', label: 'Seçenekler'}]
    }
  },
  methods: {
    ...mapActions([
      'Login_ACTION'
    ]),
    hideSoruOnizlemeModal () {
      this.$modal.hide('soruonizleme')
    },
    showSoruOnIzlemeSoru (soru) {
      this.aktifSoru = soru
      this.$modal.show('soruonizleme')
    },
    async degerlendirmeKaydet () {
      const token = this.user.token
      if (!this.form.hedefPuan || !this.form.ogrenciAciklama || !this.selected) {
        alert('Tüm alanlar dolu olmalı!')
      } else {
        const res = await postDegerlendirmeTalebi(token, this.cozulenDeneme._id, this.form.hedefPuan, this.form.ogrenciAciklama, this.selected, this.$serviceAddress)
        if (res.err !== '') {
          this.hata = res.err
        }
        this.$set(this.cozulenDeneme, 'degerlendirecekOgretmen', this.selected)
        this.open = false
        alert('Sınav Değerlendirme Kaydınız yapıldı.')
      }
    }
  },
  computed: {
    ...mapState([
      'user'
    ]),
    audiourl () {
      return this.$serviceAddress + 'audios/' + this.cozulenDeneme.geriBildirimSes
    },
    toplamPuan () {
      return Number(this.cozulenDeneme.toplamDogruSayisi) * 1.25
    }
  },
  async mounted () {
    const token = this.user.token
    const sid = this.$route.params.sinavid
    this.sinavid = sid
    // const cozulensinavid = this.cozulensinavid
    const res = await getStatics(token, sid, this.$serviceAddress)
    if (res.err === '') {
      const cevaplar = res.result.cevaplar
      const cozulenDeneme = res.result.cozulenDeneme
      const yanlislar = res.result.yanlislar
      const sorular = res.result.sorular
      const sinav = res.result.sinav
      this.hata = ''
      this.cozulenDeneme = cozulenDeneme
      this.yanlislar = yanlislar
      this.sinav = sinav
      this.sinavGenelBilgi.push({SinavAdi: this.sinav.denemeAdi, dogru: this.cozulenDeneme.toplamDogruSayisi, yanlis: this.cozulenDeneme.toplamYanlisSayisi, bos: sorular.length - (cozulenDeneme.toplamYanlisSayisi + cozulenDeneme.toplamDogruSayisi)})
      sorular.forEach(function (soru, index) {
        const cindx = _.findIndex(cevaplar, function (c) {
          return c.soruId === soru._id
        })
        if (cindx > -1) {
          if (cevaplar[cindx].cevap) {
            cevaplar[cindx].cevapUserFriendly = numberToAnswer(cevaplar[cindx].cevap)
          }
          cevaplar[cindx].dogruMu === true ? sorular[index]._rowVariant = 'success' : sorular[index]._rowVariant = 'danger'
          sorular[index].kullanicicevap = cevaplar[cindx]
        }
      })
      this.cevaplar = cevaplar
      this.sorular = sorular

      console.log(this.sinavGenelBilgi[0])
    } else {
      this.hata = res.err
    }
  }
}
</script>

<style scoped>
  .secenek {
    padding-right: 10px;
  }
  .dogruSecenek {
    color:green;
  }
  .yanlisSecenek {
    color: darkred;
  }
  .cevap {
    color: greenyellow;
  }
  .mor {
    color: #453f92;
  }
</style>



// WEBPACK FOOTER //
// src/components/SinavOzeti.vue